import React from "react";

const NotFound = () => {
  return (
    <div className="center-wrapper">
      <h1 className="standard-text">Not Found</h1>
    </div>
  );
};

export default NotFound;
